// src/components/salon-management/payment-flow/TipsDialog.tsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField
} from "@mui/material";
import { StylingStaff } from "../../../types/salon.types";

interface TipsDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  staff: StylingStaff | null;
  tipsAmount: { [key: string]: string };
  onTipsChange: (staffId: string, value: string) => void;
}

const TipsDialog: React.FC<TipsDialogProps> = ({
  open,
  onClose,
  onConfirm,
  staff,
  tipsAmount,
  onTipsChange
}) => {
  const calculateTipsTotal = () => {
    return Object.values(tipsAmount).reduce((total, tip) => {
      return total + (parseFloat(tip) || 0);
    }, 0);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" component="div">
          Add Tips
        </Typography>
      </DialogTitle>
      
      <DialogContent>
        {staff && (
          <Box key={staff._id.$oid} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body1" fontWeight="medium">
                {staff.firstName}
              </Typography>
              <TextField
                type="number"
                size="small"
                value={tipsAmount[staff._id.$oid] || ""}
                onChange={(e) => onTipsChange(staff._id.$oid, e.target.value)}
                inputProps={{ 
                  min: "0", 
                  step: "0.01",
                  placeholder: "0.00"
                }}
                sx={{ width: 100 }}
              />
            </Box>
          </Box>
        )}
        
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="body1" fontWeight="bold">
            Total Tips:
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {calculateTipsTotal().toFixed(2)} QAR
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TipsDialog;